import type {ClientInfo} from '@/context/client-types';
const UUID=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export async function recoverTransferIdentity(client:ClientInfo|null,access:(client:ClientInfo,mode:'login'|'register')=>Promise<ClientInfo>):Promise<ClientInfo>{
 if(!client)throw new Error('Inicia sesión en tu cuenta ALÉA antes de generar la transferencia.');
 if(!client.name?.trim()||!client.phone?.trim())throw new Error('Completa tu nombre y celular en Perfil para vincular la transferencia.');
 if(UUID.test(client.id||''))return client;
 // Los perfiles guardados antes del login actual podían no tener id. La RPC
 // existente reutiliza el contacto por celular; nunca registra otro si coincide.
 const mode=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(client.email||'')?'register':'login';
 const restored=await access(client,mode);
 if(!UUID.test(restored.id||''))throw new Error('No pudimos vincular tu perfil. Inténtalo nuevamente.');
 return restored;
}
